/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  cursor: pointer;
}

:host [type="button"] {
  @include button-reset-appearance;

  align-items: center;
  background-color: v(backgroundColor);
  color: v(textColor);
  border: 0;
  border-radius: 99px;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  gap: 8px;
  height: 24px;
  line-height: 21px;
  margin-bottom: 8px;
  margin-right: 8px;
  padding: 2px 12px;
  position: relative;
  transition: background-color 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s, color 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s,
    opacity 0.25s, box-shadow 0.25s;
  max-width: 100%;

  .#{$prefix}label {
    max-width: 100%;
    overflow: hidden;
    padding-bottom: 1px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .#{$prefix}icon,
  eon-ui-icon {
    color: v(iconTextColor);
    display: flex;
    height: 20px;
    justify-content: center;
  }

  &::after {
    border: 3px solid transparent;
    border-radius: 100px;
    box-shadow: 0 0 0 2px transparent;
    content: "";
    display: flex;
    height: 100%;
    left: -3px;
    position: absolute;
    top: -3px;
    width: 100%;
  }

  &:not(:disabled):hover {
    background-color: v(backgroundHoverColor);

    .#{$prefix}label::after {
      content: "";
      background-color: v(textColor);
      bottom: 4px;
      height: 1px;
      left: 0;
      position: absolute;
      width: 100%;
    }

    .#{$prefix}icon,
    eon-ui-icon {
      color: v(iconTextHoverColor);
    }
  }

  &:focus-visible {
    outline: none;
    z-index: 2; // this is needed for the label on multi select dropdowns

    &::after {
      box-shadow: 0 0 0 2px v(borderColor);
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &.#{$prefix}size-small,
  &.#{$prefix}size-tiny {
    height: 22px;
    padding-left: 10px;
    padding-right: 10px;

    &::after {
      border-width: 2px;
      left: -2px;
      top: -2px;
    }

    .#{$prefix}label {
      padding-bottom: 0;
    }
  }

  &.#{$prefix}size-tiny {
    height: 18px;
    padding-inline: 8px;
  }

  &.#{$prefix}rank-secondary {
    background-color: transparent;
    box-shadow: inset 0 0 0 2px v(backgroundColor);
    color: v(textHoverColor);

    .#{$prefix}icon,
    eon-ui-icon {
      color: v(iconBackgroundColor);
    }

    &:not(:disabled):hover {
      background-color: transparent;
      box-shadow: inset 0 0 0 3px v(backgroundHoverColor);

      .#{$prefix}icon,
      eon-ui-icon {
        color: v(backgroundHoverColor);
      }

      .#{$prefix}label::after {
        background-color: v(textHoverColor);
      }
    }

    &.#{$prefix}size-small,
    &.#{$prefix}size-tiny {
      box-shadow: inset 0 0 0 1px v(backgroundColor);

      &:not(:disabled):hover {
        box-shadow: inset 0 0 0 2px v(backgroundHoverColor);
      }
    }
  }
}
